import { User } from "./user";


export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const lOGOUT_REQUEST = 'lOGOUT_REQUEST';
export const LOADING = 'LOADING';
export const VERIFY_TOKEN = 'VERIFY_TOKEN';

export interface AuthState {
    user: User | null;
    authenticated: boolean;
    loading: boolean | null;
    error: string;
}

interface SetLoading{
    type: typeof LOADING,
    payload: boolean
}

interface LoginRequest {
    type: typeof LOGIN_REQUEST,
    payload: singInData
}
interface LoginRequestSuccess {
    type: typeof LOGIN_SUCCESS,
    payload: User
}
interface LoginRequestFailure {
    type: typeof LOGIN_FAILURE,
    payload: string
}
interface VerifyToken{
    type: typeof VERIFY_TOKEN,
    payload: boolean
}
interface LogoutRequest {
    type: typeof lOGOUT_REQUEST
}
interface SetErrorAction {
    type: typeof LOGIN_FAILURE;
    payload: string;
}
export interface singInData{
    username: string,
    password: string
}

export type AuthAction =  LoginRequest | LoginRequestSuccess | LoginRequestFailure | LogoutRequest | SetErrorAction | SetLoading | VerifyToken